<template>
    <div class="vw-100 vh-100 flex-column d-flex align-items-center overflow-auto">
      <loader v-if="loading"></loader>
      <div class="you-did-it">
      <label class="font-40 text-black font-weight-500 mt-2">You did it!</label>
        <label class="font-24 mb-3" v-if="prizes">
          To see how you fared on the leaderboard and participate in the lucky draw, please submit your details.
        </label>
        <label class="font-24 mb-3" v-else>
          To see how you fared on the leaderboard, please submit your details.
        </label>
      </div>
      <div class="w-50 d-flex flex-column justify-content-center align-items-center mb-3 pad-right">

        <div class="min-40">
        <span class="text-danger py-4 font-22" v-if="error">{{ error }}</span>
        </div>

      <div class="leader-form">

        <b-row
          class="d-flex justify-content-center align-items-center w-100 mb-3 "
        >
          <b-col cols="3">
            <label class="font-22 text-right w-100">Name <span class="text-danger">*</span></label>
          </b-col>
          <b-col cols="9">
            <b-form-input
              type="text"
              class="m-2 p-2 form-input font-16 line-height-24 font-weight-bold"
              v-model="name"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row
            v-if="!hideCompanyEmailMobile"
            class="d-flex justify-content-center align-items-center w-100 mb-3"
        >
          <b-col cols="3">
            <label class="font-22 text-right w-100">Company <span class="text-danger" v-if="!isCompanyOptional">*</span></label>
          </b-col>
          <b-col cols="9">
            <b-form-input
              type="text"
              class="m-2 p-2 form-input font-16 line-height-24 font-weight-bold"
              v-model="company"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row
            v-if="!hideCompanyEmailMobile"
          class="d-flex justify-content-center align-items-center w-100 mb-3"
        >
          <b-col cols="3">
            <label class="font-22 text-right w-100">Email <span class="text-danger">*</span></label>
          </b-col>
          <b-col cols="9">
            <b-form-input
              type="email"
              class="m-2 p-2 form-input font-16 line-height-24 font-weight-bold"
              v-model="email"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row
            v-if="!hideCompanyEmailMobile"
          class="d-flex justify-content-center align-items-center w-100 mb-3"
        >
          <b-col cols="3">
            <label class="font-22 text-right w-100">Mobile</label>
          </b-col>
          <b-col cols="9">
            <b-form-input
              type="text"
              class="m-2 p-2 form-input font-16 line-height-24 font-weight-bold"
              v-model="mobileno"
            ></b-form-input>
          </b-col>
        </b-row>
      </div>
      </div>
      <b-row class="d-flex justify-content-center align-items-center w-50 pad-right">
         <b-col cols="3">
         </b-col>
          <b-col cols="9 d-flex ">
            <button
              class="w-auto py-2 cursor-pointer px-2 bg-red d-flex text-white justify-content-center align-items-center font-26 mr-3 btn-leave"
              @click="backToIntroPage()">
              Cancel
            </button>

            <button
                v-if="hideCompanyEmailMobile"
                @click="submitDetails()"
                :disabled="!name"
                class="w-auto py-2  cursor-pointer px-5 bg-green d-flex text-white justify-content-center align-items-center font-26 btn-stay">
              Participate
            </button>

            <button
                v-else
                @click="submitDetails()"
                :disabled="(!name || !email || (!company && !isCompanyOptional))"
                class="w-auto py-2  cursor-pointer px-5 bg-green d-flex text-white justify-content-center align-items-center font-26 btn-stay">
              Participate
            </button>
          </b-col>
      </b-row>
    </div>
</template>

<script>
import { uuid } from 'vue-uuid'
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers("campaign");

export default {
  name: "UserDetailsView",
  components: {},
  data() {
    return {
      name: null,
      company: null,
      email: null,
      mobileno:null,
      error: null,
      timeout: null,
      isDestroyed: false,
      isDisabled: true,
      isCompanyOptional: true,
    };
  },
  computed: {
    ...mapState([ "leaderboard", "loading", "campaign"]),
    prizes() {
      return this.campaign?.config?.prizes ?? true;
    },
    hideCompanyEmailMobile() {
      return this.campaign?.config?.hideCompanyEmailMobile ?? false;
    },
  },
  methods: {
    ...mapActions(["uploadDetailsAndGetLeaderBoard", "getCampaignDetails"]),
    async submitDetails() {
      if (this.hideCompanyEmailMobile) {
        this.email = `anon.${uuid.v1()}`;
      }
      else {
        const emailRegx = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,6})?$/;
        if(!emailRegx.test(this.email)){
          this.error = "Please enter valid email address"
          return false;
        }
      }
      localStorage.setItem("user-email", this.email);
      localStorage.setItem("name", this.name);
      let workoutData = JSON.parse(localStorage.getItem("workoutData"));
      let accuracy = (workoutData && workoutData.accuracy) ? workoutData.accuracy : 0;
      await this.uploadDetailsAndGetLeaderBoard({
        name: this.name,
        email: this.email,
        company: this.company ?? '-',
        mobileno: this.mobileno,
        accuracy: parseFloat(accuracy),
        campaignId: this.campaign?.id,
        videoId: workoutData.videoId
      });
      await this.$router.push({name: "CampaignLeaderboard"});
    },
    backToIntroPage() {
      let message = "Are you sure about leaving?";
      if (this.prizes) {
        message = "There are prizes to be won. Are you sure about leaving?";
      }
      this.$bvModal
        .msgBoxConfirm(message, {
          modalClass: "cancelPopup edit_profile-confirm__modal update-profile",
          contentClass: "confirm__modal-contents",
          size: "sm",
          buttonSize: "sm",
          cancelVariant: "light",
          okTitle: "Stay",
          cancelTitle: "Leave",
          centered: true,
        })
        .then(async (value) => {
          /**
           * Adding an entry into the user table as anonymous user.
           * This will help in keeping track of the total count of users performing the workout.
           * This data will not be used in Leaderboard calculation.
           */
          if (!value){
            const workoutData = JSON.parse(localStorage.getItem("workoutData"));
            const accuracy = workoutData?.accuracy ?? 0;
            await this.uploadDetailsAndGetLeaderBoard({
              name: `anon.${uuid.v1()}`,
              email: `anon.${uuid.v1()}@elitefit.ai`,
              company: '-',
              accuracy: parseFloat(accuracy),
              cancelButtonClick: true,
              campaignId: this.campaign?.id,
              videoId: workoutData?.videoId
            });
            await this.$router.push({name: "CampaignIntroduction"});
          }
        })
        .catch((err) => { console.error(err) });
    }
  },
  async created() {
    const details = await this.getCampaignDetails(this.$route.params.name);
    if (!details) {
      await this.$router.push({ name: "Not Found" });
    }
  },
};
</script>

<style scoped>

.you-did-it {
   margin: 0 auto;
    margin-top: 70px;
    display: flex;
    align-items: center;
    flex-direction: column;
    max-width: 1000px;
    text-align: center;
    width: 100%;

}

.you-did-it .font-40 {
    margin: 0 !important;
    font-size: 75px;
    line-height: 90px;
    font-weight: 700;
    color: #000;
}

.you-did-it .font-24 {
    margin: 0 !important;
    font-size: 28px;
    line-height: 40px;
    margin-bottom: 40px !important;
    color: #2c2c2c;
}

.leader-form {
  width: 100%;
}

.leader-form  .form-input {
    box-shadow: rgb(0 0 0 / 24%) 3px 3px 3px 1px;
    border: 3px solid #969b92!important;
    font-size: 16px !important;
    font-weight: 500;
}

.leader-form  label {
    font-size: 22px;
    font-weight: 600;
    color: #000;
    text-align: right;
}

.leader-form  label  span {
        font-size: 16px !important;
        line-height: 14px !important;
        text-align: center;
}

.btn-leave {
    border-radius: 8px;
    font-size: 18px;
    font-weight: 600;
    height: 55px;
    background-color: #923123;
    width: 50% !important;
    margin: 0 10px;
    border: 0;
}

button:disabled{
  cursor: not-allowed;
  opacity: 0.7;
}

.btn-stay {
  margin: 0 10px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 600;
  height: 55px;
  background-color: #326E1D;
  width: 50% !important;
  border: 0;
}

.min-40 {
  min-height: 40px;
}

.pad-right {
  margin-right: 130px;
  max-width: 700px;
}

@media (max-width: 1600px) {

.you-did-it {
   margin: 0 auto;
    margin-top: 50px;
}

.you-did-it .font-40 {
    margin: 0 !important;
    font-size: 52px;
    line-height: 60px;
    font-weight: 700;
    color: #000;
}

.you-did-it {
  max-width: 800px;
}
.you-did-it .font-24 {
    margin: 0 !important;
    font-size: 22px !important;
    line-height: 30px;
    margin-bottom: 20px !important;
    color: #2c2c2c;
}

}
</style>
